import { render } from "./AdditionalRewardSettingsForm.vue?vue&type=template&id=8b040d88&ts=true"
import script from "./AdditionalRewardSettingsForm.vue?vue&type=script&lang=ts"
export * from "./AdditionalRewardSettingsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__